var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4002 9.39995H8.9002V8.89995V3.79995C8.9002 3.74473 8.94497 3.69995 9.0002 3.69995C9.05542 3.69995 9.1002 3.74473 9.1002 3.79995V8.89995V9.39995H9.6002H14.7002C14.7554 9.39995 14.8002 9.44475 14.8002 9.49995C14.8002 9.55515 14.7554 9.59995 14.7002 9.59995H9.6002H9.1002V10.1V15.2C9.1002 15.2552 9.0554 15.3 9.0002 15.3C8.945 15.3 8.9002 15.2552 8.9002 15.2V10.1V9.59995H8.4002H3.3002C3.24497 9.59995 3.2002 9.55518 3.2002 9.49995C3.2002 9.44473 3.24497 9.39995 3.3002 9.39995H8.4002Z",
    fill: "currentColor",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.c6b6cfff97881c0bf72d03e8c67a72c6.svg";
export { ForwardRef as ReactComponent };